"use client";

import logo from "@/assets/images/logo-secondary.svg";
import Link from "next/link";
import Image from "next/image";
import { footerSections, socialLinks } from "@/data/footer";
import { PrimaryButton } from "../buttons/PrimaryButton";
import { Icon } from "@iconify/react";
import logoVirtuosa from "@/assets/images/logos/logo-virtuosa-footer.png";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="flex flex-col gap-48 bg-accent p-24 md:p-48 sm:p-60 lg:p-72">
      <div className="flex flex-col items-start justify-between gap-48 lg:flex-row md:items-start ">
        <div className="flex flex-col gap-24">
          <Image src={logo} alt="Logo" width={130} height={130} />
          <p className="text-sm text-primary max-w-[257px]">
            Un club dynamique et convivial où passion du tennis rime avec esprit
            d'équipe.
          </p>
          <div className="flex items-center gap-12">
            {socialLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.label}
                className="text-primary hover:text-secondary/75 transition-colors"
              >
                <Icon icon={link.icon} width={30} height={30} />
              </a>
            ))}
          </div>
          <PrimaryButton text=" Contactez-nous" navigateTo="/#contact" />
        </div>

        <div className="flex flex-col ph:flex-row ph:flex-wrap gap-48 lg:gap-72 w-4/5 md:w-auto">
          {footerSections.map((section) => (
            <div key={section.title} className="flex flex-col gap-[10px]">
              <p className="text-sm text-primary uppercase font-bold">
                {section.title}
              </p>
              {section.links.map((link) => (
                <Link
                  key={`${section.title}-${link.label}`}
                  href={link.href}
                  className="text-sm text-primary hover:text-secondary/75"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          ))}
        </div>
      </div>
      <p className="text-sm text-secondary text-left md:text-right">
        © TCAB, {currentYear}.{" "}
        <Link
          href="https://virtuosa.fr"
          target="_blank"
          rel="noopener noreferrer"
        >
          Imaginé par Virtuosa
        </Link>
        <Link
          href="https://virtuosa.fr"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Image
            src={logoVirtuosa}
            alt="Logo Virtuosa"
            height={9}
            className="inline-block ml-1 align-middle"
          />
        </Link>
      </p>
    </footer>
  );
}
